import { useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Button, Icon } from "components/atoms";
import { ProgressBar } from "components/molecules";
import { useAuth } from "_hooks";
import { useOnBoardingGs1 } from "partner/_hooks";

let interval;
let timeouts = [];

const prefix = "vv-create-account";

const Create = () => {
  const { state } = useLocation();
  const initialized = useRef(null);
  const [step, setStep] = useState(1);
  const { account, accountError, createAccountGs1, lookAndFeel, resetEnrollmentStep } = useOnBoardingGs1();
  const { goToAccount } = useAuth();

  const init = () => {
    if (!initialized?.current) {
      initialized.current = true;
      createAccountGs1({ _id: state?._id}).catch(() => {
        timeouts.map((a) => clearTimeout(a));
      });
      interval = setInterval(() => {
        setStep((s) => {
          if (s < 2) {
            return s + 1;
          } else {
            clearInterval(interval);
            timeouts[0] =setTimeout(() => setStep(3), 10000);
            timeouts[1] = setTimeout(() => setStep(4), 60000);
            timeouts[2] = setTimeout(() => setStep(5), 110000);
            return s;
          }
        });
      }, [700]);
    }
  };

  useEffect(() => {
    init();
    return () => {
      resetEnrollmentStep();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`${prefix} h-full flex flex-col justify-center text-center gap-5`}>
      <div>
        <Icon
          icon="spinner"
          className={`mx-auto animate-spin text-6xl ${step < 3 || (step < 5 && !accountError) ? "" : "hidden"}`}
          style={{ color: lookAndFeel?.primary?.solid }}
        />
        <Icon
          icon="check" 
          className={`text-green-500 mx-auto text-6xl ${step >= 5 && !accountError ? "" : "hidden"}`}
        />
        <Icon 
          icon="closeCircle"
          className={`text-red-500 mx-auto text-6xl ${step >= 3 && !!accountError ? "" : "hidden"}`}
        />
      </div>

      <div className="max-w-[100%]">
        {(!!accountError) ?
          <ProgressBar max={5} progress={step} color="red-500" />
          :
          <ProgressBar max={5} progress={step} color={lookAndFeel?.progressbar} />
        }
      </div>
      <p className="text-3xl font-bold">
        {(step <= 2 && !accountError) && "Creando tu cuenta"}
        {(step === 3 && !accountError) && "Recuperando tus productos"}
        {(step === 4 && !accountError) && "Descargando imágenes"}
        {(step === 5 && !accountError) && "Cuenta creada correctamente"}

        {!!accountError && "Algo salió mal"}
      </p>
      
      <div>
        <p className="text-lg">
          {step <= 4 && "Esto puede tomar algunos minutos"}
          {!!accountError && "Ponte en contacto con soporte"}
        </p>
      </div>
      
      {!!accountError && <div>
        <p className="text-lg font-bold">
          <a href="mailto:soporte@nubesk.com.mx" className="underline">soporte@nubesk.com.mx</a>
        </p>
      </div>}

      {step === 5 && !accountError &&
        <Button
          className="text-white rounded-lg"
          style={{
            backgroundColor: lookAndFeel?.primary?.solid
          }}
          fullwidth
          pulse
          onClick={() => goToAccount({ token: account?.config?.userId?.tokenAccess })}
        >
          Ir a mi cuenta
        </Button>
        }
    </div>
  );
};

export default Create;
